module.exports = __webpack_public_path__ + "static/media/Referal.1a4a9821.png";